import { Departament } from "interfaces";
import { create } from "zustand";

interface DepartamentProps {
  departament: Departament | null;
  setDepartament: (departament: Departament | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  isOpenModal: boolean;
  setIsOpenModal: (state: boolean)=> void;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  clearAll: () => void;
}

export const useDepartamentStore = create<DepartamentProps>((set, get) => ({
  departament: null,
  setDepartament: (departament) => {
    set({ departament: departament });
  },
  isEdit: false,
  setIsEdit: (state) => {
    set({ isEdit: state });
  },
  isOpenModal: false,
  setIsOpenModal: (state) => {
    set({ isOpenModal: state });
  },
  handleOpenModal: () => {
    set({ isOpenModal: true });
  },
  handleCloseModal: () => {
    set({ isOpenModal: false });
  },
  clearAll: () => {
    set({
      departament: null,
      isEdit: false,
      isOpenModal: false,
    });
  },
}));